import { authApi } from "./endpoints";
import { refreshAccessToken } from "./http";
import type { MeOut } from "./types";

/**
 * Called once on app start when a previous session marker exists.
 * Tries a silent refresh (httpOnly cookie) and loads `/auth/me`.
 * Returns null when the refresh token is gone, so the caller can send the user to /login.
 */
export async function bootstrapSession(): Promise<MeOut | null> {
  const token = await refreshAccessToken();
  if (!token) return null;
  try {
    return await authApi.me();
  } catch {
    return null;
  }
}
